import { ConfigureTheStore } from "./store";

export const RedivizStore = ConfigureTheStore();
